// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__buY3H","modalFooterButton":"ModalNotes_modalFooterButton__2VVJe"};